// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__gz0aj","intro":"styles_intro__B3TAd"};